<template>
  <div>
    <el-dialog title="选择优惠券" :visible.sync="dialogPrize" width="1050px" @close="dialogClose">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <!-- Note------通用优惠券 -->
        <el-tab-pane label="通用优惠券" name="two" >
          <div class="topTis">
            <i class="el-icon-warning" style=" color: #EBAA3C;font-size: 14px"></i>
            <div class="desc">
              <p>
                仅支持通用优惠券的uuid
                <el-button style="margin: 0 60px;color:#EBAA3C" type="text" @click="handleUrl()">去创建优惠券></el-button>
              </p>
            </div>
          </div>
          <div>
            优惠券uuid:  <el-input v-model="generalCoupon.batchKey" placeholder="请输入" style="width: 200px"></el-input> <span class="toLink" @click="toLink">uuid获取教程</span>
          </div>
          <div class="generalCoupon">
            面额:  <el-input v-model.number="generalCoupon.price" placeholder="请输入" style="width: 200px"></el-input>
          </div>
          <div style="color:#2670fb;margin-top:50px">
            <el-button type="primary" style="width:150px" @click="setGeneralCoupon(); dialogVisibleFrom = false;">
                确定
              </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="小程序优惠券" name="first">
          <div class="topTis">
            <div class="desc">
              <p>
                <i class="el-icon-warning" style=" color: #EBAA3C;font-size: 14px"></i>
                支持“官方渠道推广-商家抽奖平台.“官方渠道推广-购物小程序专享券"优惠券。
                <el-button style="margin: 0 60px;color:#EBAA3C" type="text" @click="handleUrl()">去创建优惠券></el-button>
                <span style="cursor: pointer;" @click="handleUrl1()">优惠券创建教程></span>
              </p>
            </div>
          </div>
          <el-form :model="formListPrize" label-width="120px" style="margin-top:20px">
            <el-row :gutter="20" style="margin-left: -40px;">
              <el-col :span="8">
                <el-form-item label="优惠券名称:">
                  <el-input v-model="formListPrize.benefitName" placeholder="请输入" style="width: 200px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="优惠券面额:">
                  <el-input v-model="formListPrize.startAmount" placeholder="请输入" style="width: 80px"></el-input> -
                  <el-input v-model="formListPrize.endAmount" placeholder="请输入" style="width: 80px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 查询、重置按钮位置-->
                <el-button size="small" class="search" @click="handleSearch('2')">
                  <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
                  查询
                </el-button>
                <el-button size="small" class="reset" @click="handleReset('2')">重置</el-button>
              </el-col>
            </el-row>
          </el-form>
          <el-table
            v-loading="tableLoading"
            :data="prizeTable"
            style="width: 100%"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column prop="benefitName" label="名称" width="200"> </el-table-column>
            <el-table-column prop="amount" label="面额" width="120"> </el-table-column>
            <!-- <el-table-column prop="conditions" label="门槛" width="120">
              <template slot-scope="scope"> 满{{ scope.row.conditions }}元使用 </template>
            </el-table-column> -->
            <el-table-column label="使用时间" width="240">
              <template slot-scope="scope">
                起：{{ scope.row.startDate }}<br />
                止：{{ scope.row.endDate }}
              </template>
            </el-table-column>
            <el-table-column label="可发放数" prop="remainPrizeQuantity" width="120"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button style="width: 50px;margin-left: -10px;color: #2670fb;" type="text" class="Notetake" @click="chooseTab(scope.row)">
                  选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChangePrize"
            background
            @current-change="handleCurrentChangePrize"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="formListPrize.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="formListPrize.totalNum"
            :current-page="formListPrize.current"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import inputForm from "../../components/inputForm";
import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState } from "vuex";
// import { getShopGif } from "@/api/paradiseAndTaskCommonController.js";
import { couponList, jingdouList, allAccountList, redPacketList } from "@/api/integralCenter/prizeCenter.js";
import { querySellerCouponWriteList, querySellerCouponExternalList } from "@/api/integralCenter/couponWriteController";
import { getPrize } from "@/api/thd.js";
export default {
  name: "selectPrize",
  components: {
    SelectGoods,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    libaoItem: {
      type: Object,
      default() {
        return {
          name: "东券",
          num: 0,
        };
      },
    },
    //typeDefault可不传 默认京券 免费领取 不公开
    typeDefault: {
      type: Object,
      default() {
        return {
          grantType: 3, // 发放类型  传对应的id值
          display: 1, // 是否公开  传对应的id值
          type: 0, // 不禁用  传对应的id值
          noDisabled: [3], // 不禁用  传对应的id值  可不传（默认全部禁用）
        };
      },
    },
    // num != 2 JingdouCount中的prizeCount必传 计算填的京豆总数是否大于京豆总数
    JingdouCount: {
      type: Object,
      default() {
        return {
          prizeCount: 0,
        };
      },
    },
    num: {
      default: 2,
    },
  },
  computed: {
    ...mapState(["venderType"]),
  },
  watch: {
    async value(val) {
      // this.quireList();
      // if (val) {
      //   if (this.libaoItem && this.libaoItem.num === 0) {
      //     // 配置优惠券查询走这里 可默认
      //     this.formList.type = String(this.typeDefault.type);
      //     this.formList.display = String(this.typeDefault.display);
      //     this.formList.grantType = String(this.typeDefault.grantType);
      //     if (this.typeDefault && this.typeDefault.noDisabled) {
      //       this.labelList.forEach((item) => {
      //         this.typeDefault.noDisabled.forEach((i) => {
      //           if (item.value == i) {
      //             item.disabled = false;
      //           } else {
      //             item.disabled = true;
      //           }
      //         });
      //       });
      //     }
      //     this.quireList();
      //   } else {
      //     // 店铺礼包另外  不动 已些死
      //     if (this.libaoItem.prizeType == "4") {
      //       this.ruleForm.singleAmount = this.libaoItem.singleAmount;
      //       if (this.libaoItem.assetsId) {
      //         this.formLitJD.id = this.libaoItem.assetsId;
      //         const res = await jingdouList(this.formLitJD);
      //         this.selectList = res.data.records.map((item) => ({
      //           label: item.planName,
      //           value: item.id,
      //           sendTimes: item.sendTimes,
      //         }));
      //         this.planList.jingdou = res.data.records;
      //         this.ruleForm.activityName.label = res.data.records[0].planName;
      //         this.ruleForm.activityName.value = res.data.records[0].id;
      //         this.ruleForm.activityName.sendTimes = res.data.records[0].sendTimes;
      //       } else {
      //         this.getJingdouList();
      //       }
      //     }
      //     if (this.libaoItem.prizeType == "6") {
      //       this.ruleForm.point = this.libaoItem.singleAmount;
      //     }
      //     if (this.libaoItem.prizeType == "0" || this.libaoItem.prizeType == "1") {
      //       this.formList.type = this.libaoItem.prizeType;
      //       this.formList.grantType = "5";
      //       this.formList.display = "1";
      //       this.typeDefault.type = "0";
      //       this.typeDefault.display = "1";
      //       this.typeDefault.grantType = "5";
      //       this.labelList[4].disabled = false;
      //       this.quireList();
      //     }
      //   }
      // }

      this.dialogPrize = val;
      if (val) this.prizeList();
    },
  },

  data() {
    return {
      prizeTable: [],
      formListPrize: {
        size: 10,
        current: 1,
        startAmount: "",
        endAmount: "",
        rightTypeId: 3,
        benefitName: "",
        totalNum: 0,
        state: 1,
      },
      labelList: [
        { label: "促销绑定", value: "1", disabled: true },
        { label: "推送", value: "2", disabled: true },
        { label: "免费领取", value: "3", disabled: true },
        { label: "京豆换券", value: "4", disabled: true },
        { label: "互动平台", value: "5", disabled: true },
      ],
      dialogPrize: false,
      selectList: [],
      ruleForm: {
        activityName: {},
        singleAmount: "",
        point: "",
      },
      jingdouData: {},
      rules: {},
      activeName: "first",
      internalTable: [],
      externalTable: [],
      totalNum: 0,
      totalNumTwo: 0,
      formList: {
        current: 1,
        size: 10,
        isTake: 1,
        type: "",
        display: "",
        grantType: "",
      },
      formListTwo: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      // 京豆
      formLitJD: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      activeSendtimes: "",
      planList: {
        jingdou: {},
      },
      tableLoading: false,
      generalCoupon: { // 通用优惠券
        batchKey: "",
        price: "",
        assetsId: null,
        couponType: 4,
        prizeType: 1,
        singleAmount: 1,
      },
    };
  },
  created() {
    this.prizeList(); //优惠券
  },
  methods: {
    toLink() {
      window.open("https://www.yuque.com/yunduanxincrm/sd6oeu/sxapyqr9zpobldh9?singleDoc#", "_blank");
    },

    // 选择通用优惠券
    setGeneralCoupon() {
      this.$emit("closePrize", true, this.generalCoupon);
    },

    handleUrl() {
      window.open("https://fuwu.taobao.com/ser/miniAppUse.htm?articleCode=FW_GOODS-1001212154#/", "_blank");
    },
    handleUrl1() {
      window.open("https://www.yuque.com/yunduanxincrm/sd6oeu/sxapyqr9zpobldh9", "_blank");
    },
    // 优惠券
    async AlipayList() {
      const { data: res } = await getPrize({ rightTypeId: 1, size: 999, current: 1 });
      this.AlipaySelectList = res.records;
    },
    async prizeList() {
      this.tableLoading = true;
      const { data: res } = await getPrize(this.formListPrize);
      this.prizeTable = res.records;
      this.formListPrize.totalNum = res.total * 1;
      this.tableLoading = false;
    },
    //  内部搜索
    handleSearch(val) {
      this.prizeList();
    },
    // 重置
    handleReset(val) {
      this.formListPrize.benefitName = "";
      this.formListPrize.startAmount = "";
      this.formListPrize.endAmount = "";
      this.prizeList();
    },
    //分页事件
    handleSizeChangePrize(val) {
      this.formListPrize.size = val;
      this.prizeList();
    },
    handleCurrentChangePrize(val) {
      this.formListPrize.current = val;
      this.prizeList();
    },
    // 积分  京东发放
    handleConfirm() {
      // this.ruleForm.prizeType =
      let params = {
        ...this.ruleForm,
        prizeType: this.libaoItem.prizeType,
      };
      if (this.libaoItem.prizeType == "4") {
        if (!this.ruleForm.activityName.value || !this.ruleForm.singleAmount) {
          return this.$message.warning("请填写完整");
        }
      }
      if (this.libaoItem.prizeType == "6") {
        if (!this.ruleForm.point) {
          return this.$message.warning("请填写积分");
        }
      }
      let jingdouPlanList = null;
      let item = {};
      if (this.libaoItem.name == "京豆") {
        let line = this.JingdouCount;
        jingdouPlanList = this.planList.jingdou;
        item = jingdouPlanList.find((i) => {
          return i.id == this.jingdouData.couponId;
        });
        if (item) {
          if (
            line.prizeCount &&
            this.ruleForm.singleAmount &&
            Number(line.prizeCount) * Number(this.ruleForm.singleAmount) > Number(item.quantityTotal)
          ) {
            this.$message.error("京豆发放数量不能大于该京豆预算额！");
            return;
          }
          if (this.ruleForm.singleAmount && Number(this.ruleForm.singleAmount) > Number(item.quantityTotal)) {
            this.$message.error("单份奖励个数不能大于该京豆预算额！");
            return;
          }
          if (!this.ruleForm.singleAmount) {
            this.$message.error("请填写京豆单份奖励个数！");
            return;
          }
          // if (!line.prizeCount) {
          //   this.$message.error("京豆奖励需先填写奖品总份额！");
          //   return;
          // }
        }
      }
      // console.log(params, 555);
      this.$emit("closePrize", true, { ...params, quantityTotal: item.quantityTotal });
    },
    // 京东券
    chooseTab(val) {
      // let params = item;
      // params.prizeType = this.libaoItem.prizeType;
      let params = {
        singleAmount: 1,
        discount: val.amount,
        name: val.benefitName,
        couponId: val.id,
        quota: val.remainPrizeQuantity,
        couponType: 3,
      };
      // console.log(params);
      this.$emit("closePrize", true, params);
    },
    sxJingdou() {
      this.formLitJD = {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      };
      this.getJingdouList();
    },
    //查询京豆
    async getJingdouList() {
      const res = await jingdouList(this.formLitJD);
      let selectArr = res.data.records.map((item) => {
        return {
          label: item.planName,
          value: item.id,
          sendTimes: item.sendTimes,
        };
      });
      this.selectList = selectArr;
      this.planList.jingdou = res.data.records;
    },
    //获取优惠券
    quireList() {
      // this.formList.beginTime = this.nowTime;
      this.tableLoading = true;
      couponList(this.formList).then((res) => {
        this.internalTable = res.data.records;
        this.internalTable.forEach((item) => {
          item.couponType = 1;
        });
        this.totalNum = Number(res.data.total);
        this.tableLoading = false;
      });
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      querySellerCouponExternalList(this.formListTwo).then((res) => {
        this.externalTable = res.data.records;
        this.externalTable.forEach((item) => {
          item.couponType = 2;
          item.couponId = Number(item.id);
        });
        this.totalNumTwo = Number(res.data.total);
        this.tableLoading = false;
      });
    },
    //切换
    handleTabClick(val) {
      // console.log(val);
      if (val.name == "second") {
        this.querySellerCouponExternal();
      }
    },
    // 创建内部优惠券
    jumpCreation() {
      window.open("https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fpromo.shop.jd.com%2Fweb%2Fcoupon%2Fdetail%2Fshop%2F0%3F");
    },
    // 创建外部优惠券
    jumpSansCreation() {
      this.$router.push({
        path: "./prizeCenter/coupon_management",
        query: { to: 1 },
      });
    },
    // 创建京豆
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
      });
      window.open(routeUrl.href, "_blank");
    },
    planChange(val) {
      console.log(val);
      this.activeSendtimes = val.sendTimes;

      this.jingdouData = {
        couponId: val.value || "",
        // discount: this.jingduoForm.quota,
        discount: Number(val.count || ""),
        name: val.label || "",
        singleAmount: Number(val.count || ""),
      };
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handleSizeChangeTwo(val) {
      this.formListTwo.size = val;
      this.quireList();
    },
    handleCurrentChangeTwo(val) {
      this.formListTwo.current = val;
      this.quireList();
    },
    dialogClose() {
      this.$emit("closePrize", false);
    },
  },
};
</script>

<style scoped lang="scss">
.toLink {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
.couponTypebox {
  background: green;
  width: 52px;
  color: #fff;
  margin: 0 auto;
  padding: 0px 4px;
  font-size: 12px;
}
.pointer {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.topTis {
  width: 100%;
  // height: 44px;
  background: #fdf6ec;
  border-radius: 4px;
  padding: 10px 0 10px 12px;
  // .desc {
  //   color: #999;
  // }
}
.enter {
  width: 104px;
  height: 32px;
  padding: 0 10px;
  background: #2670fb;
  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  margin-top: 26px;
  color: #ffffff;
  margin-left: 20px;
}
.shuaxin {
  display: inline-block;
  line-height: 32px;
  position: relative;
  padding-left: 22px;
  margin-left: 10px;
  &::before {
    width: 20px;
    height: 20px;
    background: url("../../assets/images/integralCenter/shuaxin.png");
    position: absolute;
    left: 0px;
    content: "";
    top: 5px;
  }
}
.chuangjian {
  margin-left: 10px;
  display: inline-block;
  width: 104px;
  height: 32px;
  background: #2670fb;
  border: 1px solid #2670fb;
  line-height: 32px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}
.search {
  color: #fff;
  border: 1px solid #2670fb;
  background-color: #2670fb;
  &:hover {
    opacity: 0.8;
  }
}
.reset {
  color: #666666;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #2670fb;
    border: 1px solid #2670fb;
    background-color: rgba(38, 112, 251, 0.1);
  }
}
.generalCoupon {
  margin-top: 20px;
  margin-left: 43px;
}
.topTis {
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #fdf6ec;
  // margin: 30px;
  margin-bottom: 24px;
  padding: 12px;
  color: #333;
  margin-left: 0px;
  .desc {
    line-height: 20px;
  }
  p {
    margin-left: 5px;
    line-height: 20px;
  }
}
</style>
